var mapStyles = require('./gmaps/gmaps-styles'),
  MarkerClusterer = require('./gmaps/MarkerClusterer'),
  InfoBubble = require('./gmaps/InfoBubble'),
  Emails = require('./emails'),
  MarkerWithLabel;

var gmaps = {
  markerClickSubscribers: []
};

// Only load this one if google is defined, as it expects to find it
if (typeof google !== 'undefined' && window.google.maps) {
  MarkerWithLabel = require('./gmaps/MarkerWithLabel');
}

gmaps.initQuantityMap = function(obj) {
  var mapContainer = document.getElementById(obj.containerId);
  var data = obj.data;
  var map;
  var markers = [];
  var blankMarker = {path: window.google.maps.SymbolPath.CIRCLE, scale: 0, strokeWeight: 1, fillOpacity: 0.5, fillColor: '#ff00ff'};

  var mapOptions = {
    center: new window.google.maps.LatLng(30,15),
    zoom: 2,
    minZoom: 2,
    maxZoom: 12,
    disableDefaultUI: true,
    zoomControl: true,
    zoomControlOptions: {
      position: window.google.maps.ControlPosition.LEFT_TOP,
    },
    disableDoubleClickZoom: false,
    draggable: true,
    scrollwheel: false,
    mapTypeId: window.google.maps.MapTypeId.ROADMAP,
    styles: mapStyles, // from mapstyles.js
  };
  window.google.maps.visualRefresh = true; // Enable new style of the maps
  map = new window.google.maps.Map(mapContainer, mapOptions);

  map.setOptions({maxZoom: 4});

  // Handle data and create markers
  for (var i = 0; i < data.length; i++) {
    var d = data[i];
    var markerSize = 40 + (d.size / 500 * 60); // min 40px, 500 => 100px

    var marker = new MarkerWithLabel({
      position: new window.google.maps.LatLng(d.lat,d.lng),
      map: map,
      zIndex: Math.round(d.size),
      draggable: false,
      raiseOnDrag: false,
      labelContent: '', //
      labelAnchor: new window.google.maps.Point(markerSize / 2,50), // Center
      labelClass: 'google-maps__marker-circle google-maps__marker-circle--' + d.markerColor, // the CSS class for the label
      labelStyle: {width: d.markerSize + 'px'},
      labelInBackground: false,
      icon: blankMarker,
    });
    markers.push(marker);
    // Add click event listener for marker
    window.google.maps.event.addListener(marker,'click',function(e) {
      var newPos = new window.google.maps.LatLng(this.position.lat(),this.position.lng());
      map.panTo(newPos);
      map.setZoom(map.getZoom() + 1);
    });
  }

  window.google.maps.event.addListenerOnce(map, 'idle', function() {
    window.google.maps.event.trigger(map, 'resize');

    // Zoom to fit all markers
    gmaps.mapZoomFitMarkers(map,markers);
  });

  return map;
};
gmaps.initPopupMap = function(obj) {
  var mapContainer = document.getElementById(obj['containerId']);
  var popupContainer = document.getElementById(obj['popupContainerId']);
  var data = obj['data'];
  var map;
  var clustererMarkerUrl = obj['clustererMarkerUrl'];
  var markers = [];
  var latLngs = [];
  var blankMarker = {path: window.google.maps.SymbolPath.CIRCLE,scale: 0,strokeWeight: 0,fillOpacity: 0};
  var mapOptions = {
    center: new window.google.maps.LatLng(30,15),
    zoom: 2,
    minZoom: 2,
    maxZoom: 12,
    disableDefaultUI: true,
    zoomControl: true,
    zoomControlOptions: {
      position: window.google.maps.ControlPosition.LEFT_TOP,
    },
    disableDoubleClickZoom: false,
    draggable: true,
    scrollwheel: false,
    mapTypeId: window.google.maps.MapTypeId.ROADMAP,
    styles: mapStyles, // from mapstyles.js
  };
  window.google.maps.visualRefresh = true; // Enable new style of the maps
  map = new window.google.maps.Map(mapContainer, mapOptions);
  // Handle data and create markers
  for (var i = 0; i < data.length; i++) {
    var d = data[i];
    d.lng = gmaps.offsetOverlappingCoorinates(d.lat, d.lng, latLngs); // If needed, shift marker slightly to the right
    latLngs.push(d.lat + ',' + d.lng); // Store current/offsetted lat & lng
    var marker = new MarkerWithLabel({
      position: new window.google.maps.LatLng(d.lat ,d.lng),
      map: map,
      itemId: d.id,
      popupContainer: popupContainer,
      zIndex: Math.round(90 + d.lat),
      draggable: false,
      raiseOnDrag: false,
      labelContent: '<img src="' + d.iconUrl + '">',
      labelAnchor: new window.google.maps.Point(29, 73), // Center bottom
      labelClass: 'google-maps__marker-pin', // the CSS class for the label
      //labelStyle: {width:'58px',height:'73px'},
      labelInBackground: false,
      icon: blankMarker,
    });
    markers.push(marker);
    // Add click event listener for marker
    window.google.maps.event.addListener(marker, 'click', function(e) {
      var zoom = map.getZoom();
      var latOffset = 10 / (1000 / 12 * zoom); // zoom 2-12, latOffset 10-0.01
      var newPos = new window.google.maps.LatLng(this.position.lat() - latOffset, this.position.lng());
      var i, l;

      map.panTo(newPos);
      for (i = 0, l = gmaps.markerClickSubscribers.length; i < l; i++) {
        gmaps.markerClickSubscribers[i](this);
      }
    });
  }
  // Marker clusters
  var markerCluster = new MarkerClusterer(map, markers, {
    zoom: 2,
    gridSize: 40,
    zoomOnClick: false,
    styles: [{
      url: clustererMarkerUrl,
      width: 58,
      height: 73,
      anchor: [21, 0],
      textSize: 18,
      // Since markerclusterer.js doesn't support(!) font family or weight, use injection
      textColor: "#ffffff; font-family:'Noto Sans','sans-serif' !important; font-weight:400 !important; height:73px !important; margin-top:-32px !important",
    }],
  });
  // Add click event listener for cluster
  window.google.maps.event.addListener(markerCluster, 'clusterclick', function(cluster) {
    var map = cluster.map_;
    var zoom = map.getZoom();
    map.panTo(cluster.getCenter());
    map.setZoom(zoom + 2);
  });
  // Zoom to fit all markers
  //gmaps.mapZoomFitMarkers(map,markers);
  window.google.maps.event.addListenerOnce(map, 'idle', function() {
    window.google.maps.event.trigger(map, 'resize');
  });

  return map;
};

gmaps.initBubbleMap = function(settings) {
  var locationCenter = new window.google.maps.LatLng(settings.lat,settings.lng),
    mapCenter = new window.google.maps.LatLng(settings.lat + 0.004,settings.lng + 0.0045),
    options = {
      zoom: 14,
      center: mapCenter,
      mapTypeId: window.google.maps.MapTypeId.ROADMAP,
      scrollwheel: false,
      navigationControl: false,
      mapTypeControl: false,
      scaleControl: false,
      //draggable: false
      draggable: true
    },
    map = new window.google.maps.Map(document.getElementById(settings.containerId), options),
    marker = new window.google.maps.Marker({
      position: locationCenter,
      map: map
    }),

    infoBubble = new InfoBubble({
      map: map,
      content: '<div class="google-maps__infobubble">' + settings.infoHtml + '</div>',
      position: new window.google.maps.LatLng(-35, 151),
      shadowStyle: 0,
      padding: 10,
      backgroundColor: '#00b5e2',
      borderRadius: 4,
      arrowSize: 10,
      borderWidth: 1,
      borderColor: '#00b5e2',
      disableAutoPan: true,
      hideCloseButton: true,
      arrowPosition: 20,
      backgroundClassName: 'phoney',
      arrowStyle: 0,
      minWidth:  210,
      maxWidth:  350,
      minHeight: 160,
      maxHeight: 400
    });

  /*
  var latLng = marker.getPosition();
  //map.setCenter(latLng);
  map.panTo(mapMarker.getPosition());*/

  infoBubble.open(map, marker);
  setTimeout(function(){
    Emails.makeLinks();
  }, 1000);

  window.google.maps.event.addListener(marker, 'click', function() {
    if (!infoBubble.isOpen()) {
      infoBubble.open(map, marker);
      setTimeout(function(){
        Emails.makeLinks();
      }, 1000);
    }
  });
};

gmaps.dealersMap = function(obj) {
  var mapContainer = document.getElementById(obj.containerId);
  var data = obj.data;
  var map;
  var markers = [];

  var mapOptions = {
    center: new window.google.maps.LatLng(30,15),
    zoom: 2,
    minZoom: 2,
    maxZoom: 12,
    disableDefaultUI: true,
    zoomControl: true,
    zoomControlOptions: {
      position: window.google.maps.ControlPosition.LEFT_TOP,
    },
    disableDoubleClickZoom: false,
    draggable: true,
    scrollwheel: false,
    mapTypeId: window.google.maps.MapTypeId.ROADMAP,
    styles: mapStyles, // from mapstyles.js
  };
  window.google.maps.visualRefresh = true; // Enable new style of the maps
  map = new window.google.maps.Map(mapContainer, mapOptions);

  map.setOptions();

  // Handle data and create markers
  for (var i = 0; i < data.length; i++) {
    var d = data[i];
    var marker = new MarkerWithLabel({
      position: new window.google.maps.LatLng(d.lat,d.lng),
      map: map,
      zIndex: Math.round(d.size),
      draggable: false,
      raiseOnDrag: false,
      labelContent: '', //
      labelAnchor: d.url, // Center
      // labelClass: 'google-maps__marker-circle google-maps__marker-circle--' + d.markerColor, // the CSS class for the label
      // labelStyle: {width: d.markerSize + 'px'},
      labelInBackground: false,
      // icon: blankMarker,
    });
    markers.push(marker);
    // Add click event listener for marker
    window.google.maps.event.addListener(marker,'click',function(e) {
      // var newPos = new window.google.maps.LatLng(this.position.lat(),this.position.lng());
      // map.panTo(newPos);
      // map.setZoom(map.getZoom() + 1);
      window.open(window.location.origin+this.labelAnchor, '_self');
    });
  }

  window.google.maps.event.addListenerOnce(map, 'idle', function() {
    window.google.maps.event.trigger(map, 'resize');

    // Zoom to fit all markers
    if (obj.fitAllMarkers) {
      gmaps.mapZoomFitMarkers(map,markers);
    }
    if (obj.zoomToMarker && obj.zoomToMarker.length > 0) {
      var zoomMarker = obj.zoomToMarker[0];
      map.setCenter(new window.google.maps.LatLng(zoomMarker.lat, zoomMarker.lng));
      map.setZoom(11);
    }
  });

  return map;
};

gmaps.mapZoomFitMarkers = function(map, markers) {
  //console.log('mapZoomFitMarkers');
  //console.log(map, markers);

  if (markers.length) {
    var bounds = new window.google.maps.LatLngBounds();
    for (var i = 0; i < markers.length; i++) {
      //console.log('looping markers');
      bounds.extend(markers[i].getPosition());
    }
    map.fitBounds(bounds);
  }
};
gmaps.offsetOverlappingCoorinates = function(lat, lng, arr) {
  if (arr.indexOf(lat + ',' + lng) > -1) {
    // Found > Shift right
    var newLng = lng - 0.025;
    return gmaps.offsetOverlappingCoorinates(lat,newLng,arr);
  }
  return lng;
};

gmaps.addMarkerClickSubscriber = function(callback) {
  if (typeof callback === 'function') {
    gmaps.markerClickSubscribers.push(callback);
  }
};

module.exports = gmaps;
